angular.module("UI8.services").service("SessionService", [
  "$http",
  "$rootScope",
  "$q",
  "PreloadService",
  function ($http, $rootScope, $q, PreloadService) {
    function getRandomString() {
      return Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, "");
    }

    this.user = function () {
      if (!UI8.loggedIn) return null;
      // The SPA shell inlines the signed-in user on the first load; the
      // run block's setCurrentUser peeks, the first state resolve takes.
      var preloaded = PreloadService.take("me");
      if (preloaded) return $q.resolve(preloaded);
      return $http.get("/api/me?" + getRandomString()).then(
        function (response) {
          return response.data.user;
        },
        function () {
          return null;
        }
      );
    };

    this.setCurrentUser = function () {
      if (!UI8.loggedIn) return null;
      var preloaded = PreloadService.peek("me");
      if (preloaded) {
        $rootScope.user = preloaded;
        return $q.resolve();
      }
      return $http.get("/api/me?" + getRandomString()).then(
        function (response) {
          if (!response.data || !response.data.user) {
            $rootScope.user = null;
            return;
          }
          $rootScope.user = response.data.user;
        },
        function () {
          $rootScope.user = null;
        }
      );
    };

    this.purchases = function () {
      if (!UI8.loggedIn) return null;
      return $http.get("/api/purchases").then(
        function (response) {
          return response.data;
        },
        function () {
          return null;
        }
      );
    };
  },
]);
